import { IReport } from "@/entities";
import { BACKEND_BASE_URL, IPageResponse, IResponseError } from "../backend.types";
import { IReportRequest, IReportService } from "./report.types";
import { handleResponse } from "@/services/handlers";
import Vue from "vue";
import { AxiosRequestConfig, AxiosResponse } from "axios";

export class ReportService implements IReportService {
  async getReportsPage(
    uReportRequest?: IReportRequest | undefined
  ): Promise<IPageResponse<IReport> | undefined> {
    const { response, error } = await handleResponse<IPageResponse<IReport>, IResponseError>(
      Vue.$axios.get(`${BACKEND_BASE_URL}/api/configuration/v1/report`, {
        params: uReportRequest,
      })
    );

    if (error) {
      return undefined;
    } else {
      return response?.data;
    }
  }

  async downloadReport(idRequest: number): Promise<AxiosResponse<Blob> | undefined> {
    const postConfig = {
      headers: {
        Accept: "*/*",
        "X-Requested-With": "XMLHttpRequest",
      },
      responseType: "blob",
    } as AxiosRequestConfig;

    const { response, error } = await handleResponse<Blob, IResponseError>(
      Vue.$axios.get(
        `${BACKEND_BASE_URL}/api/configuration/v1/report/download/${idRequest}`,
        postConfig
      )
    );

    if (error) {
      return undefined;
    } else {
      return response;
    }
  }

  async deleteReport(idRequest: number): Promise<void> {
    await handleResponse<Promise<void>, IResponseError>(
      Vue.$axios.delete(`${BACKEND_BASE_URL}/api/configuration/v1/report/${idRequest}`)
    );
  }
}
